module.exports = __webpack_public_path__ + "static/mockup_phone_landing-b37f1bfe4282b4a24b221b8ca3822c7f.png";